import { useNavigate, useLocation } from "react-router-dom";
import { LuList, LuUser } from "react-icons/lu";
import { AiOutlineHome } from "react-icons/ai";
import { motion, AnimatePresence } from "framer-motion";
import { useContext } from "react";
import { GlobalStateContext } from "../context/GlobalStateContext";

const BottomBarMobile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const { isLogin } = useContext(GlobalStateContext);

  const menuItems = [
    {
      id: "home",
      icon: AiOutlineHome,
      label: "Home",
      path: "/",
      activePaths: ["/", "/purchase/outlet/"],
    },
    {
      id: "orders",
      icon: LuList,
      label: "Pesanan",
      path: isLogin ? "/purchase/transaction-list" : "/profile",
      activePaths: ["/purchase/transaction-list"],
    },
    {
      id: "profile",
      icon: LuUser,
      label: "Profil",
      path: "/profile",
      activePaths: ["/profile"],
    },
  ];

  const isMenuActive = (menu) => {
    if (menu.id === "home") {
      return currentPath === "/" || currentPath.includes("/purchase/outlet/");
    }

    return menu.activePaths.some(
      (path) => currentPath === path || currentPath.startsWith(path + "/"),
    );
  };

  return (
    <div className="block md:hidden">
      <motion.div
        className="fixed bottom-0 z-20 bg-white border-t border-gray-200 w-full h-16"
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      >
        <div className="w-full flex items-center justify-around h-full">
          {menuItems.map((menu) => {
            const Icon = menu.icon;
            const active = isMenuActive(menu);

            return (
              <motion.button
                key={menu.id}
                className={`flex flex-col items-center justify-center gap-1 w-full h-full relative ${
                  active ? "text-primary" : "text-gray-500"
                }`}
                onClick={() => navigate(menu.path)}
                whileTap={{ scale: 0.95 }}
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
              >
                <motion.div
                  animate={{
                    scale: active ? 1.1 : 1,
                    rotate: active ? [0, -10, 10, 0] : 0,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <Icon size={24} />
                </motion.div>

                <motion.span
                  className="text-md font-medium"
                  animate={{
                    y: active ? 0 : 2,
                    opacity: active ? 1 : 0.8,
                  }}
                  transition={{ duration: 0.2 }}
                >
                  {menu.label}
                </motion.span>

                <AnimatePresence>
                  {active && (
                    <motion.div
                      className="absolute bottom-0 w-10 h-1 bg-primary rounded-t-full"
                      initial={{ scaleX: 0 }}
                      animate={{ scaleX: 1 }}
                      exit={{ scaleX: 0 }}
                      transition={{ duration: 0.3 }}
                    />
                  )}
                </AnimatePresence>
              </motion.button>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};

export default BottomBarMobile;
